<template>
    <Card :title="$t('labels.arrival_declaration_status')">
        <div class="card-body">
            <ArrivalDeclarationStatusFieldsetGroup :arrival-declaration-status="arrivalDeclarationStatus" />
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton size="sm" color="teal" @click="create">
                <span>{{ $t('buttons.create') }}</span>
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';
import ArrivalDeclarationStatusFieldsetGroup from './fieldsets/ArrivalDeclarationStatusFieldsetGroup.vue';
import { httpClient } from '../../../../services/HttpClient';
export default {
    name: "CreateArrivalDeclarationStatusPage",
    components: {
        Card, AppButton, ArrivalDeclarationStatusFieldsetGroup
    },
    data() {
        return {
            arrivalDeclarationStatus: {
                uuid: null,
                name: '',
                type: '',
                color: '',
                order: 0
            }
        }
    },
    methods: {
        async create() {
            await httpClient.post('/management/arrival-declaration-statuses', {
                name: this.arrivalDeclarationStatus.name,
                color: this.arrivalDeclarationStatus.color,
                type: this.arrivalDeclarationStatus.type,
                order: this.arrivalDeclarationStatus.order
            }).then((response) => {
                this.$router.push({ name: 'EditArrivalDeclarationStatusPage', params: { arrivalDeclarationStatusUuid: response.data.data.uuid } });
            });
        }
    }
}
</script>
